import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('add_a_comment_about_the_changes_made'),
    description: defineMessage('you_are_initiating_the__e_brbr_this_is_optional'),
    buttonText: defineMessage('confirm'),
    buttonHint: defineMessage('by_pressing_this_button_and_might_be_left_empty'),
    addCommentPlaceholder: defineMessage('add_a_comment'),
};
